























































































































import { Component, Prop } from "vue-property-decorator";
import { Guid } from 'guid-typescript';

import { mixins } from "vue-class-component";
import SharedMixin from "@/mixins/SharedMixin";

import { TechAreaModel, TipologiaFornituraModel, BusinessLineTableView } from '@/services/iOrderService';
import { SectionStore } from "@/feature/Offerte/OfferEvaluation/SectionStore";

@Component({})
export default class PgaOfferEvaluationOtherComponentsTransferCreate extends mixins(SharedMixin)
{
	@Prop({ default: false, type: Boolean }) readonly restricted!: boolean;
	
	get errorSubSection() : string
	{
		let color = "";
		this.Errors.forEach((value, key) =>
		{
			if(key.includes("TransferCosts"))
				color = "error";
		});
		return color;
	}

	//Details Other Components: first row
	get businessLine() : Guid | null
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.BusinessLineId;
	}
	set businessLine(value: Guid | null)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_TECHAREA_ID(null);
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_BUSINESSLINE_ID(value);
	}

	get techArea() : Guid | null
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.TechAreaId;
	}
	set techArea(value: Guid | null)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_TECHAREA_ID(value);
	}

	get supplyTipology() : Guid | null
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.SupplyTipologyId;
	}
	set supplyTipology(value: Guid | null)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_SUPPLYTIPOLOGY_ID(value);
	}

	get componentTipology() : string
	{
		return "TRANSFER COSTS";
	}

	get description() : string
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.Description;
	}
	set description(value: string)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_DESCRIPTION(value);
	}
	
	get offerAmount() : number
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.OfferAmount;
	}
	set offerAmount(value: number)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_OFFERAMOUNT(value);
	}

	get expectedCost() : number
	{
		return SectionStore.EditOtherComponents.Command.TransferCosts.ExpectedCost;
	}
	set expectedCost(value: number)
	{
		SectionStore.SET_EDIT_OTHERCOMPONENTS_TRANSFER_EXPECTEDCOST(value);
	}

	get expectedMargin() : number
	{
		return this.offerAmount - this.expectedCost;
	}

	get expectedMarginPerc() : string
	{
		if(this.offerAmount == 0)
			return "0";
		return ((this.expectedMargin / this.offerAmount) * 100).toFixed(2);
	}

	//Dropdown Lists
	get businessLineDropdown() : Array<BusinessLineTableView>
	{
		return SectionStore.BusinessLinesDropdown;
	}
	get techAreaDropdown() : Array<TechAreaModel>
	{		
		return SectionStore.TechAreasDropdown.filter(ta => ta.BusinessLine.Id === this.businessLine);
	}
	get supplyTipologyDropdown() : Array<TipologiaFornituraModel>
	{
		return SectionStore.SupplyTipologiesDropdown;
	}

	get Errors() : Map<string, Array<string>>
	{
		return SectionStore.EditOtherComponents.Errors;
	}
}
